module.exports = __webpack_public_path__ + "static/media/suit.41ed0057.svg";